import { createStore } from "vuex";

export default createStore({
    state: {
        token: sessionStorage.getItem("token") || "",
        name: sessionStorage.getItem("name") || "",
        avatar: sessionStorage.getItem("avatar") || "",
        user: sessionStorage.getItem("user") || "",
    },
    getters: {},
    mutations: {
        setToken(state, data) {
            state.token = data;
            sessionStorage.setItem("token", data);
        },
        setName(state, data) {
            state.name = data;
            sessionStorage.setItem("name", data);
        },
        setAvatar(state, data) {
            state.avatar = data;
            sessionStorage.setItem("avatar", data);
        },
        setUser(state, data) {
            state.user = data;
            sessionStorage.setItem("user", data);
        },

    },
    actions: {

    },
    modules: {}
});
